module.exports = __webpack_public_path__ + "static/media/about-derantau-bg.01cc8a4b.png";